<template>
    <div class="conferencepaper-box">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="24" class="login-title">
                <div class="desc-box">
                    <div class="title">Paper Management</div>
                    <br />
                    <div class="info">
                        Here is the information of all your papers, including those that have been reviewed and approved,
                        which can be seen here
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="10" justify="center">
            <el-col :span="24">
                <el-button type="primary" style="margin-bottom:10px" @click="confdesc" size="small">Conference
                    Desc</el-button>
                <el-button type="primary" style="margin-bottom:10px" @click="releasepaper($route.query.cid)"
                    size="small">New Submission</el-button>
                <el-table :data="userPaperList" style="width: 100%" border :row-class-name="tableRowClassName">
                    <el-table-column label="Id" width="90" header-align="center" align="center">
                        <template #default="scope">
                            <span style="margin-left: 10px">{{ scope.row.autoid }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Authors" header-align="center" width="330">
                        <template #default="scope">
                            <el-text class="mx-1" type="primary" size="small">{{ scope.row.authors }}</el-text>
                        </template>
                    </el-table-column>
                    <el-table-column label="Title" header-align="center">
                        <template #default="scope">
                            <el-text class="mx-1" type="primary" size="small">{{ scope.row.title }}</el-text>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="250" header-align="center">
                        <template #default="scope">
                            <el-tooltip class="box-item" effect="dark" content="View paper information" placement="bottom">
                                <el-button size="small" @click="look(scope.$index, scope.row)" type="success"
                                    :icon="View"></el-button>
                            </el-tooltip>
                            <el-tooltip class="box-item" effect="dark" content="Download paper files" placement="bottom">
                                <el-button size="small" @click="download(scope.$index, scope.row)" type="primary"
                                    :icon="Document"></el-button>
                            </el-tooltip>
                            <el-tooltip class="box-item" effect="dark" content="Update paper information"
                                placement="bottom">
                                <el-button size="small" @click="modify(scope.$index, scope.row)" color="#626aef"
                                    :dark="isDark" :icon="Refresh"></el-button>
                            </el-tooltip>
                            <el-tooltip class="box-item" effect="dark" content="Delete submitted paper" placement="bottom">
                                <el-button size="small" @click="deleteEmall(scope.$index, scope.row)" type="danger"
                                    :icon="Delete"></el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <!-- 添加消息模板 -->
        <el-dialog v-model="diaMessage" width="45%" style="margin-top: 1%;padding-top: 19px;" center>
            <el-text class="mx-1" size="small">You can also send email to chairs by using the form below. All corresponding authors will receive a copy of this message too. You will be shown as the sender of this email.</el-text>
            <el-divider border-style="dashed" />
            <el-form :model="form" label-width="80px" label-position="right" :rules="rules" style="margin-top: 40px;">
                <el-form-item label="Subject:" name="subject" prop="subject">
                    <el-input v-model="form.subject" autocomplete="off" />
                </el-form-item>
                <el-form-item label="Message:" name="message" prop="message">
                    <el-input v-model="form.message" autocomplete="off" type="textarea" resize="none"
                        :autosize="{ minRows: 19, maxRows: 50 }" />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="deletepage(1)">Withdraw and Send Email</el-button>
                    <el-button type="primary" @click="deletepage(0)">
                        Withdraw without Sending Email
                    </el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex"
import { Document, Plus, Delete, Download, Refresh, View,ArrowLeftBold } from '@element-plus/icons'
import { saveAs } from 'file-saver';
import request from "../../network/request"
import { ElMessage } from 'element-plus'

const userPaperList = ref([])
const route = useRoute();
const router = useRouter()
const diaMessage = ref(false)
const form = ref({
    subject: "",
    message: ""
})
const curPaper = ref(null)

// 获取会议信息
const getConfInfo = () => {
    request.post("/paper/paperlist", {
        cid: route.query.cid
    }, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        userPaperList.value = []
        let datalist = res.data;
        datalist.forEach((item) => {
            let authornamelist = []
            item.authorList.forEach((author) => {
                authornamelist.push(author.firstname + " " + author.lastname)
            })
            let authornames = authornamelist.join(",")
            let title = item.title
            let status = ""
            if (item.isTermination == 1) {
                status = "rejected manuscript"
            }
            else if (item.status == 1) {
                status = "to be pushed"
            }
            else if (item.status == 2) {
                status = "pending review"
            }
            else if (item.status == 3) {
                status = "pending decision"
            }
            else if (item.status == 4) {
                status = "has been accepted"
            }
            userPaperList.value.push({ id: item.id, cid: item.cid, pid: item.pid, authors: authornames, title: title, status, paperfile: item.paperfile, authorList: item.authorList, emailchair: item.emailchair,autoid:item.autoid })
        })
    })
}

// 下载论文
const download = (index, row) => {
    let acronym = route.query.acronym.split(" ").join("_")
    let autoid = row.autoid
    saveAs("https://www.gdstinfo.cn/conferencefile/paperfile/" + row.paperfile, `${acronym}_paper_${autoid}.pdf`)
}

// 查看论文
const look = (index, row) => {
    request.post("/conference/detail", {
        cid: row.cid
    }, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        let conferencedetail = res.data
        router.push(`/common/detailpaper?pid=${row.pid}&acronym=${conferencedetail.acronym}&title=${conferencedetail.title}&subnum=${conferencedetail.subnum}`)
    })

}

// 修改论文
const modify = (index, row) => {
    request.post("/conference/detail", {
        cid: row.cid
    }, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        let conferencedetail = res.data
        router.push(`/common/createpaper?cid=${row.cid}&pid=${row.pid}&modify=1&acronym=${conferencedetail.acronym}&title=${conferencedetail.title}&subnum=${conferencedetail.subnum}`)

    })
}
// 删除论文
const deletepage = (caseVal) => {
    if (caseVal == 0) {
        let data = {
            pidList: [curPaper.value.pid],
        }
        request.post("/paper/delete", data).then((res) => {
            if (res.code == 200) {
                ElMessage({
                    message: 'delete successful',
                    type: 'success',
                })
                getConfInfo()
                diaMessage.value = false
            }
            else {
                ElMessage({
                    message: res.msg,
                    type: 'warning',
                })
            }
        })
    }
    else {
        let emailList = []
        // 获取主席邮件
        emailList.push(curPaper.value.emailchair)
        // 获取论文的主要联系人的邮件
        curPaper.value.authorList.forEach((author) => {
            if (author.isCorresponding == 1) {
                emailList.push(author.email)
            }
        })

        // 附件形式发送邮件
        emailList = [...new Set(emailList)]
        let data = {
            subject: form.value.subject,
            message: form.value.message,
            emailList: [...new Set(emailList)].join(","),
        }
        request.post("/authoremail", data, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
            if (res.code == 200) {
                let data = {
                    pidList: [curPaper.value.pid],
                }
                request.post("/paper/delete", data).then((res) => {
                    if (res.code == 200) {
                        ElMessage({
                            message: 'Delete successful, email has been sent',
                            type: 'success',
                        })
                        getConfInfo()
                        diaMessage.value = false
                    }
                    else {
                        ElMessage({
                            message: res.msg,
                            type: 'warning',
                        })
                    }
                })

            }
        })
    }
}

// 论文投稿
const releasepaper = (cid) => {
    request.post("/conference/detail", {
        cid: cid
    }, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        let conferencedetail = res.data
        router.push(`/common/createpaper?cid=${cid}&modify=0&acronym=${conferencedetail.acronym}&title=${conferencedetail.title}&subnum=${conferencedetail.subnum}`)

    })
}

// 跳转到会议详细页
const confdesc = () => {
    let sublink = route.query.acronym.replace("_", "").replace(" ", "").toLowerCase()
    router.push(`/common/submitpaper?conf=${sublink}`)
}

// 我的会议列表表格行样式
const tableRowClassName = ({ row, rowIndex, }) => {
    return 'success-row'
}

// 邮件弹出层
const deleteEmall = (index, row) => {
    diaMessage.value = true
    form.value.subject = `${route.query.acronym} submission ${row.pid} delete`
    curPaper.value = row
}

onMounted(() => {
    getConfInfo()
})
</script>


<style lang="scss">
.conferencepaper-box {
    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 5px;
            }
        }
    }

    .el-table .warning-row {
        background-color: #fdd9d921;
    }

    .el-table .success-row {
        background-color: #a2d2d714;
    }
}
</style>